import { render, staticRenderFns } from "./PlacesModal.vue?vue&type=template&id=1004ef68&scoped=true&"
import script from "./PlacesModal.vue?vue&type=script&lang=js&"
export * from "./PlacesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1004ef68",
  null
  
)

export default component.exports